"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimestampFormatted = exports.getNumberOfPages = exports.handleWebSocketConnection = exports.closeWebSocket = exports.updateCalendar = exports.decodeMessageContent = exports.encodeMessageContent = exports.getLastMessage = exports.getChatOverviewIcon = void 0;
const message_1 = require("../store/redux/message");
const store_1 = require("../store/redux/store");
const lodash_1 = require("lodash");
const images_1 = require("./images");
const dictionaries_1 = require("./dictionaries");
const moment_1 = __importDefault(require("moment"));
const react_native_base64_1 = __importDefault(require("react-native-base64"));
const react_native_1 = require("react-native");
const config_1 = require("../config/config");
const getChatOverviewIcon = (flightData) => {
    let icon = images_1.icons.DepartureAirport;
    let alt = 'aircraft symbol';
    if (flightData) {
        switch (flightData.status) {
            case dictionaries_1.FlightStatus.CLOSED && dictionaries_1.FlightStatus.DONE: {
                icon = images_1.icons.FlightCompleted;
                alt = 'flight completed symbol';
                break;
            }
            case dictionaries_1.FlightStatus.CANCELED: {
                icon = images_1.icons.FlightCancelled;
                alt = 'flight canceled symbol';
                break;
            }
        }
        if (flightData.request) {
            icon = images_1.icons.FlightOffer;
            alt = 'flight offer symbol';
        }
    }
    return { icon, alt };
};
exports.getChatOverviewIcon = getChatOverviewIcon;
const getLastMessage = (chat, user) => {
    const messageSender = chat.last_message?.sender?.username;
    const messageContent = chat.last_message?.content;
    const messageTime = moment_1.default.utc(chat.last_message?.timestamp).local().format("HH:mm");
    const read = chat.last_message?.sender?.id == user?.id || !!chat.last_message?.read_timestamp;
    return { messageSender, messageContent, messageTime, read };
};
exports.getLastMessage = getLastMessage;
const encodeMessageContent = (messageContent) => {
    return react_native_1.Platform.OS === "web" ?
        btoa(encodeURIComponent(messageContent)) :
        react_native_base64_1.default.encode(encodeURIComponent(messageContent));
};
exports.encodeMessageContent = encodeMessageContent;
const decodeMessageContent = (messageContent) => {
    return react_native_1.Platform.OS === "web" ?
        decodeURIComponent(atob(messageContent)) :
        decodeURIComponent(react_native_base64_1.default.decode(messageContent));
};
exports.decodeMessageContent = decodeMessageContent;
const updateCalendar = (lang, yesterday, today) => {
    moment_1.default.updateLocale(lang, {
        calendar: {
            lastDay: `[${yesterday}], HH:mm`,
            sameDay: `[${today}], HH:mm`,
            nextDay: "ddd., HH:mm",
            lastWeek: "ddd., HH:mm",
            nextWeek: "ddd., D MMMM HH:mm",
            sameElse: "ddd., D MMMM HH:mm"
        }
    });
};
exports.updateCalendar = updateCalendar;
const closeWebSocket = (wsClient) => {
    console.log("Close web Socket Function");
    if (wsClient.current && "close" in wsClient.current && wsClient.current?.readyState === WebSocket.OPEN) {
        console.log("Close web Socket Function in IF STATEMENT");
        wsClient.current.close();
    }
};
exports.closeWebSocket = closeWebSocket;
const handleWebSocketConnection = ({ currentChat, navigateToMessages, userDetails, currentFlightData, wsClient, currentInitiatorData, currentReceiverData, currentToken, setReconnectInfo, setUpdate, update, }) => {
    if ((0, lodash_1.isEqual)(currentChat, message_1.CHAT_DEFAULT_STATE.currentChat)) {
        (0, exports.closeWebSocket)(wsClient);
        setTimeout(() => {
            navigateToMessages();
        }, 10);
    }
    if (userDetails && currentFlightData && !wsClient.current) {
        wsClient.current = new WebSocket(`${config_1.API_URL.replace('http', 'ws')}chat/ws?flight_id=${currentFlightData.id}&user_id=${userDetails.id}&token=${currentToken}`);
    }
    if (userDetails && currentInitiatorData && currentReceiverData && !wsClient.current) {
        wsClient.current = new WebSocket(`${config_1.API_URL.replace('http', 'ws')}chat/ws?user_id=${userDetails.id}&initiator_id=${currentInitiatorData.id}&receiver_id=${currentReceiverData.id}&token=${currentToken}`);
    }
    if (currentToken && wsClient.current && "onopen" in wsClient.current && "send" in wsClient.current) {
        wsClient.current.onopen = () => {
            wsClient.current?.send(`Bearer ${currentToken}`);
        };
    }
    if (wsClient.current && "onmessage" in wsClient.current) {
        wsClient.current.onmessage = (event) => {
            const messages = JSON.parse(event.data);
            const decodeMessage = { ...messages[0], content: (0, exports.decodeMessageContent)(messages[0].content) };
            store_1.store.dispatch((0, message_1.sendMessageAction)(decodeMessage));
        };
    }
    if (wsClient.current && "onclose" in wsClient.current) {
        wsClient.current.onclose = async () => {
            setReconnectInfo(true);
            while (wsClient.current?.readyState === WebSocket.CLOSED) {
                try {
                    if (userDetails && currentFlightData) {
                        wsClient.current = new WebSocket(`${config_1.API_URL.replace('http', 'ws')}chat/ws?flight_id=${currentFlightData.id}&user_id=${userDetails.id}&token=${currentToken}`);
                    }
                    if (userDetails && currentInitiatorData && currentReceiverData) {
                        wsClient.current = new WebSocket(`${config_1.API_URL.replace('http', 'ws')}chat/ws?user_id=${userDetails.id}&initiator_id=${currentInitiatorData.id}&receiver_id=${currentReceiverData.id}&token=${currentToken}`);
                    }
                }
                catch (error) {
                    console.error("Error while connecting to WebSocket:", error);
                }
                await new Promise((resolve) => setTimeout(resolve, 3000));
            }
            setUpdate(!update);
            wsClient.current?.send(`Bearer ${currentToken}`);
        };
        setReconnectInfo(false);
    }
    return () => {
        if (wsClient.current && "onclose" in wsClient.current) {
            wsClient.current.onclose = (e) => {
                console.log('closed code:' + e.code);
            };
        }
    };
};
exports.handleWebSocketConnection = handleWebSocketConnection;
const getNumberOfPages = (currentMessagesCount, currentMessages) => {
    let numberOfPages = null;
    if (currentMessagesCount && currentMessages) {
        numberOfPages = Math.floor(currentMessagesCount / currentMessages.length);
        const modulo = currentMessagesCount % currentMessages.length;
        if (modulo) {
            numberOfPages++;
        }
    }
    return numberOfPages;
};
exports.getNumberOfPages = getNumberOfPages;
const getTimestampFormatted = (timestamp) => moment_1.default.utc(timestamp).local().calendar();
exports.getTimestampFormatted = getTimestampFormatted;
